import React from 'react';
import output from "./output.json";
import { SearchBar } from './components/search_bar';
import { Header } from './components/header';
import { theme } from './theme/theme';
import { ThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { Container } from '@mui/system';

const App = () => <ThemeProvider theme={theme}>
  <CssBaseline />
  <Container
    maxWidth={false}
    sx={{
      backgroundColor: theme.palette.background.paper,
      alignContent: "center",
      padding: "0 0 0 0",
      margin: "0 0 0 0",
      maxWidth: "100vw",
    }}
  >
    <Header />
    <SearchBar info={output} />
  </Container>
</ThemeProvider>
export default App;
